export function getLocationsList (type) {
    return {
        type: 'GET_LOCATIONS_LIST',
        payload: type
    }
}

export function getFpactList (takesFpact) {
    return {
        type: 'GET_FPACT_LIST',
        payload: takesFpact
    }
}



// WEBPACK FOOTER //
// ./src/actions/locationActions.js